import { SVGProps } from "react";

const CheckIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.28516 14.126C3.42285 14.126 0.223633 10.9336 0.223633 7.06445C0.223633 3.20215 3.41602 0.00292969 7.27832 0.00292969C11.1475 0.00292969 14.3467 3.20215 14.3467 7.06445C14.3467 10.9336 11.1475 14.126 7.28516 14.126ZM6.52637 10.4414C6.7793 10.4414 6.99805 10.3115 7.15527 10.0791L10.3545 5.08887C10.4502 4.93848 10.5322 4.76758 10.5322 4.61035C10.5322 4.25488 10.2246 4.01562 9.88281 4.01562C9.66406 4.01562 9.47266 4.13184 9.3291 4.37109L6.49902 8.89648L5.17969 7.22168C5.00879 7.00293 4.84473 6.9209 4.63281 6.9209C4.27734 6.9209 4.00391 7.20801 4.00391 7.55664C4.00391 7.72754 4.06543 7.8916 4.18848 8.04199L5.86328 10.0791C6.05469 10.3252 6.2666 10.4414 6.52637 10.4414Z"
      fill="#0FE000"
    />
  </svg>
);

export default CheckIcon;
